/**
 * Convert a recipe-calculated runtime value to activity runtime in hours.
 * Legacy RecipeVM used mathjs unit conversion from template.runtimeUnit to hours.
 */
export function convertRecipeRuntimeToHours(value: number, runtimeUnit?: string): number {
  if (!Number.isFinite(value)) {
    return value;
  }

  let hours = value;
  if (runtimeUnit === 'minutes') {
    hours = value / 60;
  }

  return Math.round(hours * 10) / 10;
}

/** Whether activity runtime should auto-sync from recipe calculations (instrument-based activities). */
export function shouldSyncActivityRuntimeFromRecipe(options: {
  instrument?: string;
  usesInstrument?: boolean;
}): boolean {
  return Boolean(options.instrument) || options.usesInstrument === true;
}
